import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Response, RequestOptions, Request, Headers } from '@angular/http';
import { Observable } from 'rxjs/';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  readonly rootUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private translate: TranslateService
  ) { }

  getDashboard(IDElaborazione, idTag): Observable<any> {
    let x = 'mongo';
    let data = '?mongoConnectionString=' + x + '&DB=' + x + '&collection=' + x + '&TagId=' + idTag + '&ElabId=' + IDElaborazione;
    return this.http.get(this.rootUrl + '/api/Dashboard/dashboard' + data, { headers: new HttpHeaders({ "Content-Language": localStorage.getItem('localLanguage') }) });
  }

  getDashboardDetails(idArea, elaborationID): Observable<any> {
    let x = 'mongo'
    let data = '?mongoConnectionString=' + x + '&DB=' + x + '&collection=' + x + '&AreaId=' + idArea + '&ElabId=' + elaborationID;
    return this.http.get(this.rootUrl + '/api/Dashboard/dashboardarea' + data, { headers: new HttpHeaders({ "Content-Language": localStorage.getItem('localLanguage') }) });
  }
}
